export default "__VITE_ASSET__D2GdpxwP__"